<template>
  <div class="lingue" @click.capture.stop.prevent="clickwindow">
    <b-form-select
      style="margin:0;width:auto"
      v-model="lingua"
      :options="lingue"
      @change="CambiaLingua"
      size="sm"
      :plain="$store.state.SelectPlain"
      autofocus
    ></b-form-select>
    
  </div>
</template>

<script>
export default {
  name: "Lingua",
  data() {
    return {
      lingua: "",
      lingue: [
        { value: "IT", text: "Italiano" },
        { value: "EN", text: "English" },
        { value: "DE", text: "Deutsch" }
        //{ value: "FR", text: "Français }
      ]
    };
  },
  props: {},
  watch: {
    "$store.state.Lingua"(Lingua) {
      this.lingua = Lingua;
    }
  },
  methods: {
    CambiaLingua() {
      this.$store.commit("SettaLingua", this.lingua);
    },
    clickwindow() {
    }
  },

  created() {
    this.lingua = this.$store.state.Lingua;
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
